export { default as Devil } from './component'
